<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <h1 class="display-1 font-weight-bold mx-1 mb-3">Marketing Tools</h1>
        <v-card>
          <v-card-text>
            <p class="text-body-1">
              Over the coming months we'll be adding resources to help you market our
              products. For example, to make it easy to import items into your website.
            </p>
            <p class="text-body-1">
              To start with we've added a feature allowing you to download images and
              details of our recently update Giclee editions
            </p>
            <p class="text-body-1">Watch this space for more</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  async created() {},
};
</script>
